import React from 'react';
import { BodyText } from '../../atoms';
import { LayoutGroup } from 'framer-motion';

import { Container, Tab, Underline, Wrapper } from './Tabs.styles';

export interface TabsProps {
  /** Tabs configuration */
  tabs: { label: string; id: string }[];
  /** Active Tab id */
  activeTabId?: string;
  /** Click event handler */
  onClick?: (tabId: string) => void;
}

/**
- The Tabs component organizes and allows navigation between groups of content that are related and at the same level of hierarchy.
**/
const Tabs = ({ tabs, activeTabId, onClick }: TabsProps) => {
  return (
    <Container containerVariant="primary">
      <LayoutGroup>
        {tabs.map(({ label, id }) => (
          <Wrapper key={id}>
            <Tab
              size="regular"
              onClick={() => (onClick ? onClick(id) : null)}
              title={label}
            >
              <BodyText
                variant="body3"
                fontWeight={600}
                overflow="truncate"
                textAlign="center"
              >
                {label}
              </BodyText>
            </Tab>
            {activeTabId === id ? (
              <Underline variant="primary" layout layoutId="underline" />
            ) : null}
          </Wrapper>
        ))}
      </LayoutGroup>
    </Container>
  );
};

export default Tabs;
